var styles = {
  "themeLight": "_themeLight_1jy8m1c_8",
  "themeDark": "_themeDark_1jy8m1c_11",
  "sizeS": "_sizeS_1jy8m1c_15",
  "sizeM": "_sizeM_1jy8m1c_18",
  "sizeL": "_sizeL_1jy8m1c_21",
  "modeClassic": "_modeClassic_1jy8m1c_25",
  "modeRock": "_modeRock_1jy8m1c_28",
  "modeClear": "_modeClear_1jy8m1c_31",
  "iconPlacementLeft": "_iconPlacementLeft_1jy8m1c_35",
  "iconPlacementRight": "_iconPlacementRight_1jy8m1c_39",
  "wrapper": "_wrapper_1jy8m1c_43",
  "menuItem": "_menuItem_1jy8m1c_50",
  "keyboardNavigationDisabled": "_keyboardNavigationDisabled_1jy8m1c_85",
  "selected": "_selected_1jy8m1c_99",
  "highlighted": "_highlighted_1jy8m1c_106",
  "disableCursor": "_disableCursor_1jy8m1c_107",
  "disabled": "_disabled_1jy8m1c_120",
  "content": "_content_1jy8m1c_131",
  "icon": "_icon_1jy8m1c_35",
  "divider": "_divider_1jy8m1c_144",
  "groupHeaderThemeLight": "_groupHeaderThemeLight_1jy8m1c_158",
  "groupHeaderThemeDark": "_groupHeaderThemeDark_1jy8m1c_161",
  "groupHeaderSizeL": "_groupHeaderSizeL_1jy8m1c_165",
  "groupHeaderSizeM": "_groupHeaderSizeM_1jy8m1c_168",
  "groupHeaderSizeS": "_groupHeaderSizeS_1jy8m1c_171",
  "groupHeader": "_groupHeader_1jy8m1c_158"
};
export { styles as default };
